import React, { forwardRef } from 'react';
import { Image, Popup } from '@whitesharx/starfall-frontend-ui-kit';
import {
  containerStyles,
  imageStyles,
  phrasesContainerStyles,
  phraseStyles,
  stickersContainerStyles,
  wrapperStyles,
} from './styles.css';
import { ActPhrase, ActSticker, PhrasePackName } from '../../../types';
import { getPackEmoticons, getPackPhrases, getPhraseText, getProductName } from '../../../utils/game';
import Phrase from '../../Product/Phrase';

export type EmojiSelectProps = {
  onChoose?: (type: 'phrase' | 'sticker', payload: ActPhrase | ActSticker) => void;
};

const EmojiSelect = forwardRef<HTMLDivElement, EmojiSelectProps>(({ onChoose }, ref) => {
  const content = (
    <div className={containerStyles}>
      <div className={phrasesContainerStyles}>
        {getPackPhrases('phrase1').map(({ packId, id }) => {
          const text = getPhraseText({ packId, id });
          const shrinkFont = text?.length >= 15;
          return (
            <div key={id} className={phraseStyles} onClick={() => onChoose?.('phrase', { packId, id })}>
              <Phrase packName={getProductName(packId) as PhrasePackName} size={shrinkFont ? 'extraSmall' : 'small'}>
                {text}
              </Phrase>
            </div>
          );
        })}
      </div>
      <div className={stickersContainerStyles}>
        {getPackEmoticons('emoji4').map(({ packId, id }) => {
          const src = `assets/images/shop/emoticons/${packId}/emoji.set4.${id}.webp`;
          return (
            <Image
              key={id}
              className={imageStyles}
              src={src}
              width="35px"
              height="35px"
              onClick={() => onChoose?.('sticker', { sticker: { id: `${packId}.${id}`, path: src } })}
            />
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={wrapperStyles} ref={ref}>
      <Popup arrowPlacement="bottomRight" background="primary" content={content} />
    </div>
  );
});

export default EmojiSelect;
